<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col cols="12" md="7">
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            {{ $t('company.vision.title') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col  class="display-1">
            {{ $t('company.vision.subtitle')}}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('company.vision.text.01')}}<br>
            {{ $t('company.vision.text.07')}}<br>
            <!-- {{ $t('company.vision.text.02')}}<br> -->
            {{ $t('company.vision.text.03')}}<br>
            {{ $t('company.vision.text.04')}}<br>
            {{ $t('company.vision.text.05')}}<br>
            <!-- {{ $t('company.vision.text.06')}}<br> -->
            {{ $t('company.vision.text.08')}}<br>
            <!-- {{ $t('company.vision.text.09')}}<br> -->
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="5" class="align-center">
        <!-- <v-img
          src="@/assets/img/about-vision-01.webp"
          contain
          class="mr-auto">
        </v-img> -->
        <v-row>
          <v-col cols="12">
            <v-img
              src="@/assets/img/rubin-img-01.jpg"
              contain
              class="mr-auto">
            </v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-img
              src="@/assets/img/rubin-img-07.jpg"
              contain
              class="mr-auto">
            </v-img>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="12">
            <v-img
              src="@/assets/img/rubin-img-04.jpg"
              contain
              class="mr-auto">
            </v-img>
          </v-col>
        </v-row> -->
      </v-col>
    </v-row>

    <v-row>
      <v-col>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Vision',
    extends: DataComponentBase,

    data: () => ({

    }),

    methods: {

    },
  }
</script>
